import React, { FC, useState, useRef, useEffect } from 'react';

import { Typography } from '@mui/material';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import VideoClipIcon from '../../../../assets/icons/VideoClipIcon';
import { CardLabels } from '../../../../components/Card';
import { CategoryLabel } from '../../../../components/UI/CategoryLabel';
import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { colorsPalette } from '../../../../theme';
import { SendHitsEvent } from '../../const';
import { sendAlgoliaClickEvent } from '../../helpers';
import useStyles from './styles';

interface GlossaryGridHitProps {
  hit?: any;
  sendEvent: SendHitsEvent;
}

const GlossaryGridHit: FC<GlossaryGridHitProps> = ({ hit, sendEvent }) => {
  const { t } = useTranslation();
  const [descriptionLines, setDescriptionLines] = useState(2);

  const blockRef = useRef<HTMLDivElement>(null);

  const classes = useStyles(descriptionLines)();

  const handleClickHit = () => {
    sendAlgoliaClickEvent(sendEvent, hit);
  };

  useEffect(() => {
    if (blockRef.current?.clientHeight) {
      const lines = Math.floor((blockRef.current.clientHeight - 42) / 23);
      setDescriptionLines(lines);
    }
  }, [hit]);

  return (
    <div className={classes.wrapper}>
      <CardLabels>
        <CategoryLabel
          key={hit?.videoUrl}
          wrapperClass={classes.cardLabel}
          name={t('page.discover.glossary')}
          textColor={colorsPalette.blueDark}
          bgColor={colorsPalette.yellow}
          Icon={Boolean(hit?.video_url) ? VideoClipIcon : undefined}
          iconProps={{
            color: colorsPalette.blueDark,
          }}
        />
        {hit?.categories && hit.categories?.[0] && (
          <CategoryLabel
            wrapperClass={cn(classes.cardLabel, classes.categoryLabel)}
            key={hit.categories?.[0]?.id}
            name={hit.categories?.[0]?.title}
            withDots
          />
        )}
      </CardLabels>
      <Link to={`${DEFAULT_DISCOVER_URL}/glossary/${hit?.slug}`} onClick={handleClickHit}>
        <Typography className={classes.title} variant="h3">
          {hit?.title}
        </Typography>
      </Link>
      <div className={classes.infoWrapper} ref={blockRef}>
        <Typography className={cn(classes.description)}>{hit?.description}</Typography>
        <Link
          className={classes.link}
          to={`${DEFAULT_DISCOVER_URL}/glossary/${hit?.slug}`}
          onClick={handleClickHit}
        >
          {t('page.discover.readMore')}
        </Link>
      </div>
    </div>
  );
};

export default GlossaryGridHit;
